import React, { useState } from 'react';
import { useModal } from 'components/shared/hooks';
import { translate } from 'javascripts/translations/i18n';
import { Modal, Button, InputText, Notice } from '@companycam/slab-web';

export type SaveAsTemplateModalProps = {
  onSaveAsTemplate: (title: string, description?: string) => void;
};

const SaveAsTemplateModal = ({
  onSaveAsTemplate,
}: SaveAsTemplateModalProps) => {
  const { hideModal } = useModal();

  const [title, setTitle] = useState('');

  return (
    <Modal
      title={translate('projectPage.saveAsTemplateModalTitle')}
      isOpen
      onClose={hideModal}
      size="small"
      footerActions={
        <>
          <Button onClick={hideModal}>{translate('common.cancel')}</Button>
          <Button
            color="primary"
            disabled={title.trim().length === 0}
            onClick={() => onSaveAsTemplate(title)}
          >
            {translate('common.save')}
          </Button>
        </>
      }
    >
      <InputText
        id="page-template-title-input"
        label={translate('common.title')}
        onChange={(e) => setTitle(e.target.value)}
        status="normal"
        value={title}
        type="search"
        autoFocus
      />

      <Notice color="info" ccMargin="m none none none">
        {translate('projectPage.saveAsTemplateNoticeMessage')}
      </Notice>
    </Modal>
  );
};

export default SaveAsTemplateModal;
